import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  container: {
    paddingTop: 0,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  questionsContainer: {
    width: '100%',
    overflowY: 'auto',
    paddingBlock: 2,
    marginBlock: 2,
  },
  radioGroup: {
    justifyContent: 'flex-end',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
  },
  radioButton: {
    width: '3em',
    height: '2em',
  },
  markAllContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
}));

export const styles = {
  radioGroup: {
    justifyContent: 'flex-end',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
  },
  radioButton: {
    width: '3em',
    height: '2em',
  },
};
export default useStyles;
